import { FC } from "react";

import { Box, Stack } from "@mui/material";

import { LiveEditorBlock } from "@/components/LiveEditorElements/LiveEditorBlock/LiveEditorBlock";
import { DashboardSkeleton } from "@/dashboard-design-system/Skeleton/DashboardSkeleton";

export const BackgroundStyleSelectorSkeleton: FC = () => {
  return (
    <LiveEditorBlock gap={1.5}>
      <DashboardSkeleton variant="text" width={120} height={20} />

      <DashboardSkeleton variant="rounded" width="100%" height={48} sx={{ borderRadius: 1 }} />

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "repeat(3, 1fr)", sm: "repeat(5, 1fr)", lg: "repeat(6, 1fr)" },
          gap: 1,
        }}
      >
        {Array.from({ length: 5 }).map((_, index) => (
          <Stack key={index} alignItems="center" gap={1} sx={{ padding: 2 }}>
            <DashboardSkeleton variant="rounded" width={24} height={24} />
            <DashboardSkeleton variant="text" width={40} height={14} />
          </Stack>
        ))}
      </Box>
    </LiveEditorBlock>
  );
};
